import type {PageRouteConfig} from '@router';

import PromotionCenter from 'modules/Services/PromotionCenter/PromotionCenter';

export function createPromotionCenterRoute(): PageRouteConfig {
  return {
    element: <PromotionCenter />,
    layout: {
      title: 'ترقی',
      hasNavigate: true,
      hasHeader: true,
      hasBack: false,
      hasLeftIcon: false,
      headerDataKey: 'promotionCenter',
      link: -1
    },
    initialHeaderData: {
      promotionCenter: {icon: '', iconTitle: '', action: null, title: ''}
    }
  };
}
